<template>
  <div :class="{ 'table-scroll': isScroll, 'table-pad': true }">
    <table class="table-list" cellspacing="0" cellpadding="0">
      <thead>
        <tr v-if="secondColumns.length === 0">
          <slot name="title"></slot>
          <th v-for="item in getFields" :key="item">
            {{ dataConfig[item].name }}
          </th>
        </tr>
        <tr v-else>
          <slot name="title"></slot>
          <th v-for="item in Object.keys(dataConfig)" :key="item">
            <div>{{ dataConfig[item].name }}</div>
            <div v-if="(Object.keys(dataConfig[item].map)).length">
              <span class="th-span" v-for="key in Object.keys(dataConfig[item].map)" :key="key">
                {{ dataConfig[item].map[key].name }}
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody v-if="secondColumns.length === 0">
        <tr v-for="item in dataList" class="table-ins-td" :key="item.key">
          <td class="table-list-name" v-for="(key, num) in firstColumns" :key="num">
            <span v-if="key !== 'store_name'">
              {{ getText(item, key) }}
            </span>
            <span v-else>
              <cell
                class="table-store"
                is-link
                :title="item[key]"
                v-if="item[key] !== '合计'"
                :link="`/saleAnalysis/saleCount?store_id=${item.store_id}&type=${number}`">
              </cell>
              <span v-else>{{ item[key] }}</span>
            </span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr v-for="item in dataList" :key="item.key">
          <td v-for="(key, num) in firstColumns" :key="num">
            <div v-if="item[key][count] >= 0">
              <span class="tr-span">{{ item[key][count] }}</span>
              <span class="tr-span">{{ item[key][rate] > 0 ? `${(item[key][rate] * 100).toFixed(0)}%` : item[key][rate] }}</span>
            </div>
            <div v-else>
              {{item[key]}}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { Cell } from '@lx-frontend/cvux'
import index from '../tableConfig/index'
export default {
  components: {
    Cell
  },
  props: {
    number: Number,
    config: {
      type: String,
      required: true
    },
    isScroll: {
      type: Boolean,
      required: false
    },
    firstField: {
      type: String,
      required: true
    },
    count: {
      type: String,
      required: false
    },
    rate: {
      type: String,
      required: false
    },
    params: {
      type: Object,
      required: false
    },
    isNotContacted: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      dataList: [],
      dataConfig: {},
      firstColumns: [],
      secondColumns: []
    }
  },
  computed: {
    getFields () {
      return Object.keys(this.dataConfig)
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      if (this.isNotContacted) {
        this.dataConfig = index[this.config].field_from_api1
      } else {
        this.dataConfig = index[this.config].field_from_api
      }
      this.initLabel()
      index[this.config].getData.call(this, this.params)
    },
    initLabel () {
      this.firstColumns = Object.keys(this.dataConfig)
      this.firstColumns.forEach(item => {
        if (this.dataConfig[item].map) {
          let newArr = Object.keys(this.dataConfig[item].map)
          this.secondColumns = this.secondColumns.concat(newArr)
        }
      })
      this.firstColumns.unshift(this.firstField)
    },
    query (config, params) {
      index[config].getData.call(this, params)
    },
    getText (item, key) {
      var obj = this.dataConfig[key]
      if (obj && obj.hasOwnProperty('is_rate')) {
        if (obj.is_rate) {
          return item[key] > 0 ? `${(item[key] * 100).toFixed(0)}%` : item[key]
        } else {
          return item[key]
        }
      } else {
        return item[key]
      }
    }
  },
  watch: {
    isNotContacted () {
      this.initData()
    }
  }
}
</script>
